import { useState } from "react";

import useUser from "../../../../core/hooks/use-user";
import useModal from "../../../../core/hooks/use-modal";
import Datatable from "../../../../core/ui/components/Datatable";
import { toast } from "../../../../core/helpers/message-helper";
import FormNominaTurno from "../components/form-nomina-turno";
import { API_URL } from "../../../../core/config/env";
import ContentWrapper from "../../../../core/ui/components/Layout/ContentWrapper";
import { inactivarTurno, verTurno } from "../../services/nomina-turnos-service";

const NominaTurnos = () => {
    const { getAccessToken, userCan } = useUser();
    const token = getAccessToken();
    const [dtInstance, onDtInstance] = useState({});

    const modalTurnos = useModal({
        title: "Agregar Turno",
        data: { turno: {} },
    });

    const onSaved = () => {
        modalTurnos.set({ show: false });
        toast.success("Turno creado correctamente");
        dtInstance.ajax.reload();
    };

    const getDtInstance = (dt) => onDtInstance(dt);
    let tableButtons = [];

    if (userCan("nominaCrearTurnos")) {
        tableButtons.push({
            titleAttr: "Agregar turno",
            text: '<i class="fas fa-plus"></i>',
            action: function () {
                modalTurnos.set({
                    show: true,
                    title: "Agregar Turno",
                    data: { turno: {} },
                });
            },
            className: "btn btn-sm btn-secondary",
        });
    }

    if (userCan("nominaEditarTurnos")) {
        tableButtons.push({
            titleAttr: "Editar turno",
            text: '<i class="fas fa-pen"></i>',
            action: async function (e, dt) {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                const resp = await verTurno(data.id);
                const turno = {
                    ...resp.data,
                    sedes: resp.data.sedes.map((sede) => {
                        return {
                            label: sede.nombre.replace(/[^a-zA-Z ]/g, ""),
                            value: sede.id,
                        };
                    }),
                };

                modalTurnos.set({
                    show: true,
                    title: "Editar Turno",
                    data: { turno },
                });
            },
            className: "btn btn-sm btn-primary",
        });
    }

    if (userCan("nominaInactivarTurno")) {
        tableButtons.push({
            titleAttr: "Inactivar turno",
            text: '<i class="fas fa-trash"></i>',
            action: async function (e, dt) {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                const resp = await inactivarTurno(data.id);
                if (!resp.status) return toast.error(resp.message);

                toast.success(resp.message);
                dt.ajax.reload();
            },
            className: "btn btn-sm btn-danger",
        });
    }

    tableButtons = [
        ...tableButtons,
        {
            titleAttr: "Exportar a Excel",
            text: '<i class="fas fa-file-excel"></i>',
            extend: "excelHtml5",
            className: "btn btn-sm btn-success",
            exportOptions: {
                modifier: {
                    order: "current",
                    page: "all",
                },
            },
            filename: "turnos",
        },
        {
            titleAttr: "Imprimir",
            text: '<i class="fa fa-lg fa-print"></i>',
            extend: "print",
            className: "btn btn-sm btn-warning",
        },
    ];

    const dtOptions = {
        searchable: true,
        serverSide: false,
        dom: "Bfrtip",
        id: "tablaTurno",
        select: {
            style: "single",
        },
        buttons: tableButtons,
        ajax: {
            url: `${API_URL}/turnos`,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", `Bearer ${token}`);
            },
            type: "get",
            dataType: "json",
            error: () => {
                toast.error(
                    "Ha ocurrido un error al obtener el listado de turnos"
                );
            },
        },
        columns: [
            { data: "id" },
            { data: "nombre" },
            { data: "sigla" },
            { data: "horas" },
            { data: "inicio" },
            { data: "fin" },
            { data: "inicio_receso" },
            { data: "fin_receso" },
            { data: "pagado" },
            { data: "libre" },
            { data: "color" },
        ],
        columnDefs: [
            {
                targets: [8, 9],
                createdCell: function (td, cellData) {
                    td.textContent = cellData == 1 ? "Si" : "No";
                    td.classList.add(
                        cellData == 1 ? "text-success" : "text-warning"
                    );
                    td.classList.add("text-bold");
                },
            },
            {
                targets: [10],
                createdCell: (td, cellData) => {
                    td.innerHTML = `
                        <div style="width: 30px; height: 30px; background-color: ${cellData}"></div>
                    `;
                },
            },
        ],
    };

    return (
        <ContentWrapper>
            <div className="content-heading">
                <div>
                    NÓMINA / Turnos
                </div>
            </div>
            <Datatable options={dtOptions} dtInstance={getDtInstance}>
                <table className="w-100 table table-hover text-center" id="tablaTurno">
                    <thead className="bg-dark">
                        <tr>
                            <th className="text-center text-white">Consecutivo</th>
                            <th className="text-center text-white">Nombre</th>
                            <th className="text-center text-white">Sigla</th>
                            <th className="text-center text-white">Horas Totales</th>
                            <th className="text-center text-white">Hora inicio</th>
                            <th className="text-center text-white">Hora Fin</th>
                            <th className="text-center text-white">Inicio Receso</th>
                            <th className="text-center text-white">Fin Receso</th>
                            <th className="text-center text-white">Turno Pagado</th>
                            <th className="text-center text-white">Turno Libre</th>
                            <th className="text-center text-white">Color</th>
                        </tr>
                    </thead>
                </table>
            </Datatable>
            <FormNominaTurno modalState={modalTurnos} onSaved={onSaved} />
        </ContentWrapper>
    );
};

export default NominaTurnos;
